import { PresetSchema } from "@redotech/redo-fulfillment-parcel-common/presets";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updatePreset = {
  name: "updatePreset" as const,
  input: z.object({
    _id: zExt.objectId(),
    preset: PresetSchema.omit({ _id: true }),
  }),
  output: z.object({ success: z.boolean() }),
};
